import type { Routes } from '@angular/router'
import { AuthGuard } from '../auth/auth-guard.service'
import { FrameworkGuard } from '../framework/framework-guard.service'
import { PRODUCT_CONFIGURATION, type ProductConfiguration } from '@awork/_shared/services/product/product-configuration'

/**
 * Builds the existing full application with the selected product provider.
 * @param {ProductConfiguration} productConfiguration Selected product.
 * @returns {Routes} Full application routes.
 */
export const createAworkRoutes = (productConfiguration: ProductConfiguration): Routes => [
  {
    path: '',
    providers: [{ provide: PRODUCT_CONFIGURATION, useValue: productConfiguration }],
    children: [
      {
        path: 'recorder',
        loadComponent: () => import('../_shared/components/recorder/recorder.component').then(m => m.RecorderComponent)
      },
      {
        path: '',
        loadChildren: () => import('../auth/auth.routes')
      },
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../framework/framework.routes').then(m =>
                m.createFrameworkRoutes(productConfiguration.id === 'aworkAI')
              ),
            canActivate: [FrameworkGuard]
          }
        ]
      },
      {
        path: '',
        redirectTo: '/auth',
        pathMatch: 'full'
      }
    ]
  }
]
